import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import { useNavigate, useLocation} from 'react-router-dom'
import InputAdornment from "@mui/material/InputAdornment";
import { loginWithEmail} from '../../../firebase/firebase'
import firebase from '../../../firebase/firebase'
import {useContext} from "react";
import {AuthUserContext} from "../../../providers/AuthProvider";
import GoogleIcon from '@mui/icons-material/Google';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import {useIntl} from 'react-intl'
import Spinner from "../../../components/spinner";
import loginValidation from "../../../validation/loginValidation";
import AppBar from "@mui/material/AppBar";
import { EmailRounded} from '@mui/icons-material';
import HttpsIcon from '@mui/icons-material/Https';
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import IconButton from "@mui/material/IconButton/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import TopBar from "../../../components/TopbarV4";
export default function ForgotYourPasswordStep2(){
    const [loading, setLoading] = React.useState(false)
    const [open, setOpen] = React.useState(false)
    const { user, setUser, profile, setProfile } = useContext(AuthUserContext);
    const navigator = useNavigate();
    const location= useLocation();
    const {messages} = useIntl()
    const formik = useFormik({
        initialValues: loginValidation.initialValues,
        validationSchema: loginValidation.loginSchema,
        onSubmit: async (values) => {
            const { email,
                password,
            } = values;

            try {
                setLoading(true)

                await loginWithEmail(email, password);
                const user = firebase.auth().currentUser;
                const usersRef = firebase.firestore().collection('users');
                // window.localStorage.setItem('user', JSON.stringify(user))

                const data = await usersRef.where('uid', '==', user.uid).get();
                setLoading(false)

                if (data?.docs[0]?.data()?.userType === 'creator') {
                    navigator('/creator/dashboard');

                } else if (data?.docs[0]?.data()?.userType === 'investor'){
                    navigator('/investor/dashboard')

                } else {
                    navigator('/admin/user-analytics')
                }
            } catch (e) {
                setLoading(false)
                alert(JSON.stringify(e, null, 2));
            }
        },
    });
    if (loading) return <Spinner/>;
    return(
        <>
            <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
            {/* Hero unit */}

            <Container  maxWidth="lg" component="main" sx={{}}>
                <Box sx={{pl: 10, pr: 10, mt:5 }}>

                    <Typography variant="h4" align="left" color="text.primary" component="p">
                        Welcome back!
                    </Typography>
                </Box>

            </Container>
            {/* End hero unit */}
            <Container maxWidth="lg" component="main" sx={{mt:5}}>
                <Grid container spacing={2}  sx={{pl: 10, pr: 10}}>
                    <Grid item xs={12}>
                        <Box   component="form" onSubmit={formik.handleSubmit} sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            mb: 2,
                            flexDirection:'column',
                        }}
                        >
                            <Grid container spacing={2}>

                                <Grid item xs={12}>
                                    <Typography fontWeight={400} fontSize={"24px"} textAlign="start">
                                        Password*
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        error={formik.touched.password && Boolean(formik.errors.password)}
                                        helperText={formik.touched.password && formik.errors.password}
                                        name='password'
                                        label={messages?.joinNow?.create_new_account?.form?.password}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <HttpsIcon sx={{color:"#204488"}}/>
                                                </InputAdornment>
                                            ),
                                        }}
                                        variant="outlined" sx={{width:'100%'}} type="password"/>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography fontWeight={400} fontSize={"24px"} textAlign="start">
                                        New password confirmation*
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        error={formik.touched.password && Boolean(formik.errors.password)}
                                        helperText={formik.touched.password && formik.errors.password}
                                        name='password'
                                        label={messages?.joinNow?.create_new_account?.form?.password}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <HttpsIcon sx={{color:"#204488"}}/>
                                                </InputAdornment>
                                            ),
                                        }}
                                        variant="outlined" sx={{width:'100%'}} type="password"/>
                                </Grid>

                                <Container  maxWidth="lg"  component="main" sx={{  }}>

                                    <Stack spacing={2} direction="row" sx={{
                                        display: 'flex',
                                        justifyContent: 'center ',
                                        alignItems: 'center',
                                        mt:5
                                    }}>
                                        {/*<Button variant="text" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5, fontSize: 'larger'}}   onClick={() => navigator(-1)}>Back</Button>*/}
                                        <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,alignItems:"center",justifyContent:"center"}} type='submit'>Next</Button>
                                    </Stack>
                                </Container>
                                <Container  maxWidth="lg"  component="main" sx={{ mt: '35px', mb: '20px'}}>
                                    <div style={{backgroundColor: '#000', width: '100%', height:1,} }/>
                                    <div style={{width: '75px', margin: 'auto', top: '-13px', position: 'relative'}}>
                                        <Typography sx={{backgroundColor: '#FBFBFB', textAlign:"center" }}>
                                            {messages?.joinNow?.create_new_account?.OR}
                                        </Typography>
                                    </div>
                                </Container>
                                <Container  maxWidth="lg"  component="main" sx={{  mb:5}}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                        <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0"  }} startIcon={<img src="/assets/imdb.png" style={{height: 25 }} alt="imdb "/>}>
                                            IMDb
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>

                                            <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0" }} startIcon={<img src="/assets/Twitter.png" style={{height: 25 }} alt="twitter "/>}>
                                                Twitter
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button  variant="outlined" sx={{width: '100%', pt: 1.2, pb:1.2, pl: 5, pr:5, color: "#a0a0a0" }} startIcon={<img src="/assets/Linkedin.png" style={{height: 25 }} alt="linkedin"/>}>
                                                Linkedin
                                            </Button>
                                        </Grid>

                                    </Grid>
                                </Container>
                            </Grid>


                        </Box>
                    </Grid>

                </Grid>


            </Container>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='lg'
            >
                <DialogTitle id="alert-dialog-title" >
                    <Stack direction={'row'} spacing={2}>
                        <Typography variant={'h6'} sx={{flex:1}}>Thank you!</Typography>
                        <IconButton sx={{color:'rgba(0, 0, 0, 0.87)'}} onClick={() => setOpen(false)}>
                            <CloseIcon/>
                        </IconButton>
                    </Stack>


                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" >
                        <Typography variant={'body2'}>Your password has been reset successfully.</Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingX: 3, paddingY: 2}}>
                    <Button onClick={() => setOpen(false)} size={'small'} sx={{color: '#000',paddingX: 3}}>Not now</Button>
                    <Button  variant={'contained'} color={'warning'} sx={{paddingX: 3}} size={'small'} onClick={() => {
                        setOpen(false);
                        navigator('/auth/login')
                    }}>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>


        </>
    )
}